<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md11>
        <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <DepartmentDialog :model="user" v-if="get_dialogMain.dialog" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import DataTable from '@/components/DataTableLocal'
import DepartmentDialog from '@/components/dialog/catalogo/DepartmentDialog'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'ID', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-3', action: 'toEditData' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTable,
    DepartmentDialog
  },
  mounted () {
    this.getDataUrl('empresa.departamentos')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('empresa.departamentos')
    },
    newData (item) {
      this.user = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 600, title: 'Nuevo Departamento' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    toEditData (item) {
      this.user = item.item
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 600, title: 'Editar Departamento' })
    },
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('empresa.departamentos')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
